import { SearchOutlined } from '@ant-design/icons';
import { Button, Drawer, Input, Modal } from 'antd';
import SelectClass from 'common/component/Inputs/SelectClass';
import SelectSection from 'common/component/Inputs/SelectClassSection';
import { KButton } from 'common/component/KButton';
import useDebounce from 'common/hooks/useDebounce';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import { StudentResponseModel } from 'data/student/student.model';
import usePagination from 'features/users/hooks/usePagination';
import { useUser } from 'features/users/hooks/useUser';
import ViewCard from 'features/users/view/components/ViewCard';
import AddCardForm from 'features/users/view/useCardForm';
import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import StudentDetails from '../modals/StudentDetails';
import KSpinner from 'common/component/KSpinner';
import StudentIdCard from '../StudentIdCard';

type ActionFunction = (row: StudentResponseModel) => void;

const studentViewTable = (
  onAssignCard: ActionFunction,
  onViewCard: ActionFunction,
): TableColumn<StudentResponseModel>[] => [
  {
    name: 'Full name',
    cell: (row): string => row?.__user__.full_name || '',
    grow: 1,
    maxWidth: '500px',
  },
  {
    name: 'Class/Section',
    cell: (row): JSX.Element => <>{row.sectionId.replace('-', ', ')}</>,
  },
  {
    name: 'Card',
    cell: (row): JSX.Element => (
      <>
        {row?.__user__.card_number ? (
          <Button onClick={(): void => onViewCard(row)} type="link">
            View Card Details
          </Button>
        ) : null}

        <Button onClick={(): void => onAssignCard(row)} type="link">
          Assign Card
        </Button>
      </>
    ),
  },
];

const IdsView = (): JSX.Element => {
  const [filters, setFilters] = React.useState<{
    class: string;
    section: string;
  }>({
    class: '',
    section: '',
  });

  const [searchValue, setSearchValue] = React.useState<string>('');

  const students = useSelector((state: RootState) => state.studentData);

  const { fetchStudent } = useUser();

  const handleFiltersUpdate = (field: 'class' | 'section') => (value: string): void => {
    setFilters({
      ...filters,
      [field]: value,
    });
  };

  const db_search = useDebounce<string>(searchValue.toLowerCase(), 500);

  const searchFilteredStudents = React.useMemo(() => {
    if (!db_search.length) return students.data.data;

    return [...students.data.data].filter(
      (item) => item?.__user__.full_name.toLowerCase().search(db_search) > -1,
    );
  }, [students.data.data, db_search]);

  const filteredStudents = React.useMemo(() => {
    return [...searchFilteredStudents].sort((a, b) => {
      // eslint-disable-next-line
      //   return a?.__user__.full_name < b?.__user__.full_name ? -1 : 1;
      return a.roll - b.roll;
    });
  }, [searchFilteredStudents]);

  const { handlePageChange, handlePerRowsChange, paginatedData, rowsPerPage } = usePagination(
    filteredStudents,
  );

  const reload = (): void => {
    fetchStudent(1, 10000, filters.class, filters.section, searchValue);
  };

  React.useEffect(() => {
    fetchStudent(1, 10000, filters.class, filters.section, searchValue);
    handlePageChange(1);
  }, [filters, searchValue]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '20px 0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <section style={{ marginRight: 35 }}>
            <h2 style={{ margin: 0 }}>Students</h2>
          </section>
          <section className="page-tabs" style={{ width: 200, margin: 0, marginRight: 15 }}>
            <SelectClass onChange={handleFiltersUpdate('class')} />
          </section>
          <section className="page-tabs" style={{ width: 200, margin: 0, marginRight: 15 }}>
            <SelectSection gradeId={filters.class} onChange={handleFiltersUpdate('section')} />
          </section>
          <section className="page-tabs" style={{ width: 200, margin: 0, marginRight: 15 }}>
            <Input
              placeholder="Search By Name"
              value={searchValue}
              onChange={(ev): void => setSearchValue(ev.target.value)}
              addonAfter={<SearchOutlined />}
            />
          </section>
        </div>
        <div className="relaod">
          <KButton onClick={reload}>Reload</KButton>
        </div>
      </div>
      {students.data?.data.map((item) => (
        <StudentIdCard type="student" details={item} reload={reload} />
      ))}
    </>
  );
};

export default IdsView;
